import { render, staticRenderFns } from "./UserPattern.vue?vue&type=template&id=a331985e&scoped=true&"
import script from "./UserPattern.vue?vue&type=script&lang=js&"
export * from "./UserPattern.vue?vue&type=script&lang=js&"
import style0 from "./UserPattern.vue?vue&type=style&index=0&id=a331985e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a331985e",
  null
  
)

export default component.exports